<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90.07 90.07">
  <g>
    <path class="cls-2" d="m36.99,47.21l-7.24-1.59c-1.92-.44-3.24-.98-3.97-1.6-.72-.63-1.08-1.39-1.08-2.29,0-1.07.55-1.97,1.63-2.68,1.07-.72,2.94-1.08,5.59-1.06,2.66.02,5.25.42,7.82,1.21,2.56.79,4.78,1.85,6.65,3.19l3.34-9.16c-1.74-1.26-3.85-2.3-6.3-3.12-2.45-.83-5.07-1.39-7.85-1.67l.05-7.06-8.92-.06-.06,7.39c-3.94.7-7.14,2.26-9.6,4.68-1.68,1.65-2.78,3.59-3.33,5.81-.25,1.03-.39,2.13-.39,3.29-.04,6.6,3.93,10.79,11.91,12.6l1.91.44,5.34,1.22c.42.1.82.21,1.18.32.58.05,1.17.07,1.77.07,4.33,0,8.37-1.25,11.79-3.4-1.79-3.19-5.2-5.36-10.23-6.52Z"/>
    <path class="cls-2" d="m42.35,59.35c-.02,2.24-.79,4.14-2.3,5.69-1.52,1.55-3.55,2.56-6.08,3.02l-.03,4.6-5.56-.04.04-4.48c-1.39-.17-2.71-.51-3.98-1.03-1.27-.51-2.3-1.15-3.13-1.9l2-5.35c.95.76,2.08,1.34,3.39,1.77,1.31.42,2.71.64,4.2.65,1.39,0,2.47-.24,3.25-.74s1.17-1.15,1.18-1.95c0-.54-.22-.98-.67-1.35-.35-.28-.9-.53-1.66-.76.36.03.73.04,1.1.04,2.7,0,5.22-.78,7.34-2.12.63,1.11.94,2.43.93,3.95Z"/>
  </g>
  <path class="cls-1" d="m35.44,59.28c-.69,0-1.33-.03-1.95-.08-2.45-.19-4.85-.76-7.14-1.69-7.68-3.1-13.18-9.8-14.74-17.92-.29-1.5-.43-3.04-.43-4.57,0-13.38,10.88-24.26,24.26-24.26s24.26,10.88,24.26,24.26c0,8.38-4.23,16.05-11.33,20.53-3.88,2.44-8.35,3.73-12.93,3.73Zm0-44.21c-11,0-19.95,8.95-19.95,19.95,0,1.26.12,2.53.36,3.76,1.28,6.68,5.81,12.19,12.12,14.74,1.88.76,3.86,1.23,5.88,1.39.52.04,1.03.07,1.6.07,3.77,0,7.45-1.06,10.64-3.07,5.83-3.68,9.32-9.99,9.32-16.88,0-11-8.95-19.95-19.95-19.95Z"/>
  <path class="cls-1" d="m75.66,79.31c-.83,0-1.65-.32-2.28-.95l-24.11-24.11c-1.26-1.26-1.26-3.31,0-4.57,1.26-1.26,3.31-1.26,4.57,0l24.11,24.11c1.26,1.26,1.26,3.31,0,4.57-.63.63-1.46.95-2.28.95Z"/>
</svg>
</template>

<script>
export default {
    name: "PriceAnalysisIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: #0f5b71;
  }
  .cls-2 {
    fill: #59c5c7;
  }
</style>